import { useQuery } from '@tanstack/react-query';

import { cacheKeys } from '../config';
import { funFactClient } from '../client/funFactClient';

type Options = {
  enabled?: boolean;
};

const defaultOptions: Partial<Options> = {
  enabled: true,
};

export const useFunFactsQuery = (params: FunFacts.GetListParams = {}, options: Partial<Options> = defaultOptions) => {
  const { data: { data } = {}, ...rest } = useQuery({
    queryKey: [cacheKeys.getFunFacts, params],
    queryFn: () => funFactClient.getFunFacts(params),
    enabled: options.enabled,
  });

  return {
    ...rest,
    count: data?.count || 0,
    funFacts: data?.results || [],
  };
};
